const SET_GAP_STEPS = "SET_GAP_STEPS";
const SET_GAP_STEPS_PROMISE = "SET_GAP_STEPS_PROMISE";

export {
    SET_GAP_STEPS,
    SET_GAP_STEPS_PROMISE,
};
